import { cn } from "@/lib/utils";

interface IconProps extends React.HTMLAttributes<HTMLImageElement> {
  icon: string;
  path?: string;
  size?: number;
}

export function Icon({
  icon,
  path = "",
  size = 24,
  className,
  ...props
}: IconProps) {
  const iconPath = `${path}/${icon}`;

  return (
    <img
      src={iconPath}
      alt={`${icon} icon`}
      width={size}
      height={size}
      className={cn("inline-block", className)}
      {...props}
    />
  );
}
